var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"padding-top":"50px"}},[(_vm.justList)?_c('infoList',{attrs:{"column_code":_vm.columnCode}}):_vm._e(),(!_vm.justList)?_c('downList',{attrs:{"column_code":_vm.columnCode}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }